import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  private readonly iconPath = 'assets/icons/';
  private readonly registeredIcons: Set<string> = new Set();
  private readonly registeringIcons: Set<string> = new Set(); // Track icons currently being registered

  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
    private readonly http: HttpClient
  ) {}

  registerIcon(iconName: string) {
    // Return early if already registered or currently being registered
    if (!iconName || this.registeredIcons.has(iconName) || this.registeringIcons.has(iconName)) {
      return;
    }

    // Mark as being registered to prevent concurrent registrations
    this.registeringIcons.add(iconName);
    
    try {
      const url = this.iconPath + iconName + '.svg';
      
      // Register with MatIconRegistry
      this.iconRegistry.addSvgIcon(iconName, this.sanitizer.bypassSecurityTrustResourceUrl(url));
      
      // Mark as registered immediately
      this.registeredIcons.add(iconName);
      
      // Quick runtime check: try to fetch the SVG
      // Only make HTTP call once per icon
      this.http.get(url, { responseType: 'text' }).subscribe(
        (body) => {},
        (err) => {}
      );
    } catch (error) {
      
    } finally {
      // Remove from registering set after registration completes (success or error)
      this.registeringIcons.delete(iconName);
    }
  }

   
}
